import {
  Injectable,
  ApplicationRef
} from '@angular/core';
import {
  Observable,
  interval,
  of,
  TimeoutError
} from 'rxjs';
import {
  map,
  startWith,
  filter,
  share,
  switchMap,
  timeout,
  catchError,
  tap,
  distinctUntilChanged
} from 'rxjs/operators';
import { LifeCycleService } from '../life-cycle/life-cycle.service';
import { NGXLogger } from 'ngx-logger';

@Injectable({ providedIn: 'root' })
export class OnlineService {
  public online$: Observable<boolean>;
  public speed$: Observable<number>;
  public secure: boolean;

  constructor(public lifeCycle: LifeCycleService, public logger: NGXLogger) {
    this.secure = location && location.protocol === 'https:';
    this.speed$ = this.lifeCycle.whenStable(() => interval(5 * 60 * 1000).pipe(
      startWith(null),
      map(() => {
        const nav: any = navigator;
        return nav && nav.connection ? nav.connection.downlink : 0;
      }),
      distinctUntilChanged(),
      tap(speed => this.logger.debug('[OnlineService::speed$]', speed)),
    ));
    this.online$ = this.lifeCycle.whenStable(() => interval(60 * 1000).pipe(
      startWith(null),
      map(() => navigator.onLine),
      distinctUntilChanged(),
      tap(online => this.logger.debug('[OnlineService::online$]', online)),
    ));
  }
}
